<script>
import { get_currency, get_decimal } from "../../../Helper/helper";
import { orderService } from "../../../services";
import OrderShow from "./order-show";
import OrderAction from "./order-action";
import OrderAssign from "./order-assign";
export default {
  components: { OrderShow, OrderAction, OrderAssign },
  props: {
    orders: {
      default: {},
      type: Object,
    },
    orderStatus: String,
    loading: {
      default: true,
      type: Boolean,
    },
    "extra-columns": {
      default: function () {
        return [];
      },
      type: Array,
    },
    status: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      filters: {
        order_status: this.order_status,
      },
      meta: [
        { charset: "utf-8" },
        { equiv: "Content-Type", content: "text/html" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
      ],
      decimal: get_decimal(),
      currency: get_currency(),
      fields: [
        {
          key: "order_id",
          label: this.trans.get("__JSON__.Order ID"),
          sortable: false,
        },
        //{ key: "vendor_name", label: this.trans.get("__JSON__.Vendor's Name1"), sortable: false },
        {
          key: "customer_name",
          label: this.trans.get("__JSON__.Customer Name"),
          sortable: false,
        },
        {
          key: "order_date",
          label: this.trans.get("__JSON__.Time"),
          sortable: false,
        },
        {
          key: "total_amount",
          label: this.trans.get("__JSON__.Amount"),
          sortable: false,
        },
        {
          key: "payment_method",
          label: this.trans.get("__JSON__.Payment"),
          sortable: false,
        },
        ...(this.extraColumns || []),
        {
          key: "action",
          label: this.trans.get("__JSON__.Action"),
          sortable: false,
        },
      ],
      showModal: false,
      order: null,
      viewIndex: 0,
      orderId: null,
      abandonedstatus: "",
      current_from_time:null,
      current_to_time:null,
      timeSlot:[],
    };
  },
  computed: {
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.$auth.partner_login)
        return this.fields.filter((field) => !field.requiresAdmin);
      // If the user IS an admin, return all fields.
      else return this.fields;
    },
    pickupOrders() {
      return this.orders?.data?.filter(order => order.delivery_type === 0) || []; 
    },
    sortedTimeSlots() {
      const parseTime = (time) => {
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
      };

      // Get current date and time
      const currentDateTime = new Date();
      const currentHour = currentDateTime.getUTCHours() + 2; // Germany timezone adjustment
      const currentMinutes = currentDateTime.getUTCMinutes();
      const currentTimeInMinutes = currentHour * 60 + currentMinutes;

      // Combine and sort the time slots
      const sortedSlots = this.timeSlot
        .map(slot => ({
          ...slot,
          from_time_minutes: parseTime(slot.from_time),
          to_time_minutes: parseTime(slot.to_time)
        }))
        .sort((a, b) => a.from_time_minutes - b.from_time_minutes);
      // Filter and include current and future time slots and previous ones with orders
      const resultSlots = sortedSlots.filter(slot => 
        slot.from_time_minutes >= currentTimeInMinutes || 
        this.getOrdersForTimeslot(slot).length > 0
      );
      // Mark the first slot as the current one, if any
      resultSlots.forEach(slot => {
        if (slot.from_time_minutes <= currentTimeInMinutes && slot.to_time_minutes > currentTimeInMinutes) {
          slot.isCurrent = true;
        }
      });

      // Map back to the original format, removing the minutes properties
      return resultSlots.map(slot => ({
        ...slot,
        from_time_minutes: undefined,
        to_time_minutes: undefined
      }));
    },
  },
  mounted() {
    this.getTimeSlot();
    //this.$data.fields[1].label = this.$auth.setting && this.$auth.setting.restaurant_name;
  },
  methods: {
    // showLoader(flag){
    //   console.log('flag')
    //   this.$emit('showLoader',flag);
    //   return true;
    // },
    onRowClicked(item) {
      this.viewDetails(item.base_id);
    },
    viewDetails(id) {
      this.showModal = true;
      this.orderId = id;
    },

    viewPageDetails(item, index, event) {
      this.viewIndex = index;
      this.viewDetails(item.base_id);
      this.$refs.selectableTable.clearSelected();
    },
    abandonedStatusChange() {
      this.$emit("abandonedstatusEmitchanged", this.abandonedstatus);
    },
    getOrdersForTimeslot(timeslot) {
      return this.orders.data.filter(order => 
        order.delivery_type === 1 &&
        order.delivery_from_time === timeslot.from_time && 
        order.delivery_to_time === timeslot.to_time
      );
    },
    getTimeSlot(page=1){
      orderService.getTimeSloApi({
          ...this.filters,
          page
        }).then((response) => {
          this.timeSlot = response.data.result;
          // this.timeSlot.sort((a, b) => b.order_count - a.order_count);
          // this.getTimeSlotForCurrentTime();
          // this.previousTimeSlot();
          this.$emit("filterChange", this.filters);
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    getTimeSlotForCurrentTime() {
      const currentDateTime = new Date();
      const currentHour = currentDateTime.getUTCHours() + 2; // Germany timezone adjustment
      const currentMinutes = currentDateTime.getUTCMinutes();

      for (let i = 0; i < this.timeSlot.length; i++) {
        const timeSlot = this.timeSlot[i];
        const [fromHour, fromMinutes] = timeSlot.from_time.split(':').map(Number);
        const [toHour, toMinutes] = timeSlot.to_time.split(':').map(Number);

        if (
          (currentHour > fromHour || (currentHour === fromHour && currentMinutes >= fromMinutes)) &&
          (currentHour < toHour || (currentHour === toHour && currentMinutes <= toMinutes))
        ) {
          this.current_from_time = timeSlot.from_time;
          this.current_to_time = timeSlot.to_time;
          return timeSlot;
        }
      }
      return ''; // No matching time slot found
    },
    getPaymentMethodClass(order) {
      return {
        'badge-soft-success': order.payment_method == 'Cash On Delivery',
        'badge-soft-warning': order.payment_method != 'Cash On Delivery',
      };
    },
    handleOrderActionClick(event) {
      event.stopPropagation(); 
    },
    // hasDeliveryOrders(timeslot) {
    //   const orders = this.getOrdersForTimeslot(timeslot);
    //   return orders.length > 0 && orders.some(order => order.delivery_type == '1');
    // },
    // hasOrdersForTimeslot(timeslot) {
    //   const orders = this.getOrdersForTimeslot(timeslot);
    //   return orders.length > 0;
    // },
    formatTimeSlot(timeslot) {
      return `${timeslot.from_time.substring(0, 2)}-${timeslot.to_time.substring(0, 2)}`;
    }
  },
};
</script>
<template>
  <div class="col-12 m-order-main pr-0 pl-0">
    <div class="m-order-main">
      <div class="row" v-if="status == 'PaymentFailure'">
        <div class="col-10">
          <span class="text-warning"
            ><strong>{{ trans.get("__JSON__.Pending") }} : </strong></span
          >
          <span class="text-warning">{{
            trans.get("__JSON__.Customer did not proceed with Payment.")
          }}</span
          ><br />
          <span class="text-danger"
            ><strong>{{ trans.get("__JSON__.Failed") }} : </strong></span
          >
          <span class="text-danger">{{
            trans.get(
              "__JSON__.Customer tried to pay but failed due to issue with Card/Bank/Wallet."
            )
          }}</span
          ><br />
          <span class="text-info"
            ><strong>{{ trans.get("__JSON__.Awaiting") }} : </strong></span
          >
          <span class="text-info">{{ trans.get("__JSON__.Awaiting") }}</span>
        </div>
        <div class="col-2">
          <label>{{ trans.get("__JSON__.Status") }} :</label>
          <select
            class="custom-select"
            v-model="abandonedstatus"
            @change="abandonedStatusChange"
          >
            <option value="" selected>{{ trans.get("__JSON__.All") }}</option>
            <option value="PaymentPending">
              {{ trans.get("__JSON__.Pending") }}
            </option>
            <option value="PaymentFailure">
              {{ trans.get("__JSON__.Failed") }}
            </option>
            <option value="AwaitForPayment">
              {{ trans.get("__JSON__.Awaiting") }}
            </option>
          </select>
        </div>
      </div>

      
      <div class="order-table-data table-responsive order-data-table">
        <h5>Pickup Orders</h5>
        <table class="table table-centered table-nowrap table-hover table-main-border order-menu mt-0">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Parking Place</th>
              <th>Customer Type</th>
              <th>Customer Name</th>
              <th>Time</th>
              <th>Amount</th>
              <th>Payment</th>
              <th v-for="col in extraColumns" :key="col.key">{{ col.label || col.key }}</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="9" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>{{ trans.get("__JSON__.Loading...") }}</strong>
              </td>
            </tr>
            <tr v-if="!loading && pickupOrders.length === 0">
              <td colspan="9" class="text-center">
                {{ trans.get("__JSON__.No Order Found") }}
              </td>
            </tr>
            <tr v-for="order in pickupOrders" :key="order.order_id" @click="onRowClicked(order)">
              <td>
                <span class="font-weight-bold">{{ order.order_id }}</span>
                <span class="badge badge-pill badge-soft-success font-size-12" v-if="order.delivery_type == '0'">
                  {{ trans.get("__JSON__.Pickup") }}
                </span>
              </td>
              <td>
                <span v-if="order.delivery_type == '0'"> {{ "Pickup Place" }} </span>
              </td>
              <td>
                <span v-if="order.customer_type == '1'"> {{ 'Private' }} </span>
                <span v-if="order.customer_type == '5'"> {{ 'Business ' }} </span>
              </td>
              <td> {{ order.customer_name }} <br>{{ order.customer_company_name ? '(' + order.customer_company_name + ')' : '' }}</td>
              <td>
                <span v-if="order.status_name == 'Placed'">
                    {{ moment(order.order_date).fromNow() }}
                    <span v-b-tooltip.hover.v-light :title="order.order_date" class="font-size-15">
                      <i class="bx bx-info-circle"></i>
                    </span>
                  </span>
                  <span v-else-if="order.status_name == 'ReadyToCollect'">
                    {{ moment(order.order_date).fromNow() }}
                    <span v-b-tooltip.hover.v-light :title=" moment(order.order_date).format('YYYY-MM-DD HH:mm:ss')" class="font-size-15">
                      <i class="bx bx-info-circle"></i>
                    </span>
                  </span>
                  <span v-else-if="order.status_name == 'OnTheWay'">
                    {{ moment(order.order_date).fromNow() }}
                    <span v-b-tooltip.hover.v-light :title="order.order_date" class="font-size-15">
                      <i class="bx bx-info-circle"></i></span>
                    </span>
                  <span v-else-if=" order.status_name == 'Delivered' && order.is_delivered == '1'">{{ moment(order.order_date).fromNow() }}
                    <span v-b-tooltip.hover.v-light :title="order.order_date" class="font-size-15">
                      <i class="bx bx-info-circle"></i>
                    </span>
                  </span>
                  <span v-else-if="order.status_name == 'Cancelled'">
                    {{ moment(order.order_date).fromNow() }}
                    <span v-b-tooltip.hover.v-light :title="order.order_date" class="font-size-15">
                      <i class="bx bx-info-circle"></i></span>
                    </span>
                  <span v-else>
                    {{ moment(order.order_date).fromNow() }}
                    <span v-b-tooltip.hover.v-light :title="order.order_date" class="font-size-15">
                      <i class="bx bx-info-circle"></i>
                    </span>
                  </span>
              </td>
              <td>{{ parseFloat(order.total_amount || 0).toFixed(decimal) }}<span v-html="currency"></span></td>
              <td>
                <span class="badge badge-pill font-size-12"
                    :class="{
                      'badge-soft-success': order.payment_method == 'Cash On Delivery',
                      'badge-soft-warning': order.payment_method != 'Cash On Delivery',
                    }"
                    v-if="
                      order.order_status !== 'PaymentPending' &&
                      order.order_status !== 'PaymentFailure' &&
                      order.order_status !== 'AwaitForPayment'
                    "
                  >
                    {{ order.payment_method == "Cash On Delivery" ? "COD" : order.payment_method }}
                  </span>
                  <span
                    v-else
                    class="badge badge-pill font-size-12"
                    :class="{
                      'badge-soft-warning':
                      order.order_status == 'PaymentPending',
                      'badge-soft-danger': order.order_status == 'PaymentFailure',
                      'badge-soft-info': order.order_status == 'AwaitForPayment',
                    }"
                  >
                    {{
                      order.order_status == "PaymentPending"
                        ? trans.get("__JSON__.Pending")
                        : order.order_status == "PaymentFailure"
                        ? trans.get("__JSON__.Failed")
                        : trans.get("__JSON__.Awaiting")
                    }}
                </span>
              </td>
              <td v-for="col in extraColumns" :key="col.key">
                <template v-if="col.key.indexOf('date') !== -1">
                  <span>{{ moment(order[col.key]).fromNow() }}</span>
                  <span v-b-tooltip.hover.v-light :title="order[col.key]" class="font-size-15">
                    <i class="bx bx-info-circle"></i>
                  </span>
                </template>
                <template v-else-if="col.key === 'driver'">
                  <span>-</span>
                </template>
              </td>
              <td>
                <OrderAction :order="order" :orderStatus="orderStatus" @actionChanged="$emit('refreshData')" @click.stop="handleOrderActionClick"/>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="order-table-data table-responsive order-data-table" v-for="(timeslot, index) in sortedTimeSlots" :key="timeslot.id">
        <h5 :class="index === 0 ? '' : 'd-none'">Delivery Orders</h5>
          <table class="table table-centered table-nowrap table-hover table-main-border order-menu mt-0" >
            <thead>
              
              <tr :class="index === 0 ? '' : 'd-none'">
                <th>Order ID</th>
                <th>Parking Place</th>
                <th>Customer Type</th>
                <th>Customer Name</th>
                <th>Time</th>
                <th>Amount</th>
                <th>Payment</th>
                <th v-for="col in extraColumns" :key="col.key">{{ col.label || col.key }}</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="9" :class="{'current-slot': timeslot.isCurrent, 'default-slot-color': !timeslot.isCurrent}">
                  <div class="timeslot-row">
                    <strong>Timeslot: {{ formatTimeSlot(timeslot) }} Uhr</strong> 
                  </div>
                </td>
              </tr>
              <tr v-if="loading">
                <td colspan="9" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>{{ trans.get("__JSON__.Loading...") }}</strong>
                </td>
              </tr>
              <tr v-if="!loading && getOrdersForTimeslot(timeslot).length === 0">
                <td colspan="9" class="text-center">
                  {{ trans.get("__JSON__.No Order Found") }}
                </td>
              </tr>
              <tr v-for="order in getOrdersForTimeslot(timeslot)" :key="order.order_id" @click="onRowClicked(order)">
                <td>
                  <span class="font-weight-bold">{{ order.order_id }}</span>
                  <span class="badge badge-pill badge-soft-primary font-size-12" v-if="order.delivery_type == '1'">
                    {{ trans.get("__JSON__.Delivery") }}
                  </span>
                  <!-- <br v-if="order.delivery_type == '1'">
                  <span v-if="order.delivery_type == '1'">({{ moment(order.delivery_from_time, 'HH:mm').format('HH:mm') }} - {{ moment(order.delivery_to_time,'HH:mm').format('HH:mm') }})</span> -->
                  <!-- <br v-if="order.future_delivery_date != '0000-00-00 00:00:00' && order.future_delivery_date != null">
                  <span class="badge badge-pill badge-success font-size-12" v-if="order.future_delivery_date != '0000-00-00 00:00:00' && order.future_delivery_date != null">
                    Scheduled
                  </span> -->
                </td>
                <td>
                  <span v-if="order.delivery_type == '1'">
                    {{order.parking_place}}
                  </span>
                </td>
                <td>
                  <span v-if="order.customer_type == '1'">
                    {{ 'Private' }}
                  </span>
                  <span v-if="order.customer_type == '5'">
                    {{ 'Business ' }}
                  </span>
                </td>
                <td>
                  {{ order.customer_name }} <br>{{ order.customer_company_name ? '(' + order.customer_company_name + ')' : '' }}
                </td>
                <td>
                  <span v-if="order.status_name == 'Placed'"
                      >{{ moment(order.order_date).fromNow() }}
                      <span
                        v-b-tooltip.hover.v-light
                        :title="order.order_date"
                        class="font-size-15"
                        ><i class="bx bx-info-circle"></i></span
                    ></span>
                    <span v-else-if="order.status_name == 'ReadyToCollect'"
                      >{{ moment(order.order_date).fromNow() }}
                      <span
                        v-b-tooltip.hover.v-light
                        :title="
                          moment(order.order_date).format('YYYY-MM-DD HH:mm:ss')
                        "
                        class="font-size-15"
                        ><i class="bx bx-info-circle"></i></span
                    ></span>
                    <span v-else-if="order.status_name == 'OnTheWay'"
                      >{{ moment(order.order_date).fromNow() }}
                      <span
                        v-b-tooltip.hover.v-light
                        :title="order.order_date"
                        class="font-size-15"
                        ><i class="bx bx-info-circle"></i></span
                    ></span>
                    <span
                      v-else-if="
                        order.status_name == 'Delivered' &&
                        order.is_delivered == '1'
                      "
                      >{{ moment(order.order_date).fromNow() }}
                      <span
                        v-b-tooltip.hover.v-light
                        :title="order.order_date"
                        class="font-size-15"
                        ><i class="bx bx-info-circle"></i></span
                    ></span>
                    <span v-else-if="order.status_name == 'Cancelled'"
                      >{{ moment(order.order_date).fromNow() }}
                      <span
                        v-b-tooltip.hover.v-light
                        :title="order.order_date"
                        class="font-size-15"
                        ><i class="bx bx-info-circle"></i></span
                    ></span>
                    <span v-else
                      >{{ moment(order.order_date).fromNow() }}
                      <span
                        v-b-tooltip.hover.v-light
                        :title="order.order_date"
                        class="font-size-15"
                        ><i class="bx bx-info-circle"></i></span
                    ></span>
                  <!-- Repeat similar conditionals for other statuses -->
                </td>
                <td>
                  {{ parseFloat(order.total_amount || 0).toFixed(decimal) }}
                  <span v-html="currency"></span>
                </td>
                <td>
                  <span
                      class="badge badge-pill font-size-12"
                      :class="{
                        'badge-soft-success': order.payment_method == 'Cash On Delivery',
                        'badge-soft-warning': order.payment_method != 'Cash On Delivery',
                      }"
                      v-if="
                        order.order_status !== 'PaymentPending' &&
                        order.order_status !== 'PaymentFailure' &&
                        order.order_status !== 'AwaitForPayment'
                      "
                    >
                      {{ order.payment_method == "Cash On Delivery" ? "COD" : order.payment_method }}
                    </span>
                    <span
                      v-else
                      class="badge badge-pill font-size-12"
                      :class="{
                        'badge-soft-warning':
                        order.order_status == 'PaymentPending',
                        'badge-soft-danger': order.order_status == 'PaymentFailure',
                        'badge-soft-info': order.order_status == 'AwaitForPayment',
                      }"
                    >
                      {{
                        order.order_status == "PaymentPending"
                          ? trans.get("__JSON__.Pending")
                          : order.order_status == "PaymentFailure"
                          ? trans.get("__JSON__.Failed")
                          : trans.get("__JSON__.Awaiting")
                      }}
                  </span>
                </td>
                <td v-for="col in extraColumns" :key="col.key">
                  <template v-if="col.key.indexOf('date') !== -1">
                    <span>{{ moment(order[col.key]).fromNow() }}</span>
                    <span v-b-tooltip.hover.v-light :title="order[col.key]" class="font-size-15">
                      <i class="bx bx-info-circle"></i>
                    </span>
                  </template>
                  <template v-else-if="col.key === 'assign' && !$auth.partner_login">
                    <OrderAssign :order="order" v-if="order.delivery_type == '1'" @actionChanged="$emit('refreshData')" />
                  </template>
                  <template v-else-if="col.key === 'driver'">
                    <span v-if="order.driver && order.driver.length > 0">
                      {{ order.driver[0].firstname }} {{ order.driver[0].lastname }}
                    </span>
                    <span v-else>-</span>
                    <!-- {{ order.driver[0]?.firstname }} {{ order.driver[0]?.lastname }} -->
                  </template>
                  <!-- Add more conditions here if needed -->
                </td>
                <td>
                  <OrderAction :order="order" :orderStatus="orderStatus" @actionChanged="$emit('refreshData')" @click.stop="handleOrderActionClick"/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>

    <OrderShow
      v-if="showModal"
      :order-id="orderId"
      :orderStatus="orderStatus"
      @hidden="showModal = false"
      @actionChanged="$emit('refreshData')"
    />
    <!-- View Detail Main End -->
  </div>
</template>
<style scoped>
.current-slot {
  background-color: #F25F5C !important;
  font-size: 0.893rem !important;
}
.default-slot-color{
  background-color: #f8f9fa !important;
  font-size: 0.893rem !important;
}
.order-data-table table tbody tr td{
    width: 13% !important;
}
.order-data-table table tbody tr td:nth-child(2){
    width: 13% !important;
}
</style> 